import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";
import mapActivityLogEntry from "slices/activityLog/mapActivityLogEntry";

const ACTIVITY_URL = "/api/activity/summary/log";
const BD_CAPTURE_AREA = "BD_CAPTURE";

export const CAPTURE_ACTIVITY_PAGE_SIZE = 50;

export const fetchCaptureActivityFeed = createAsyncThunk(
  "captureActivity/fetchFeed",
  async (
    { offset = 0, pageSize = CAPTURE_ACTIVITY_PAGE_SIZE } = {},
    { getState }
  ) => {
    const { search, sort } = getState().capture.activity;
    const { data } = await localhost.get(ACTIVITY_URL, {
      params: {
        offset,
        pageSize,
        area: BD_CAPTURE_AREA,
        sort: sort.field,
        order: sort.direction,
        ...(search ? { q: search } : {}),
      },
    });
    return {
      offset,
      rows: data.rows.map(mapActivityLogEntry),
      total: data.total,
      filteredTotal: data.filteredTotal,
    };
  }
);
